import { createContext, useContext } from "react";
import { ToastContainer, toast } from 'react-toastify';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const notify = {
        success: (msg, options = {}) => toast.success(msg, options),
        error: (msg, options = {}) => toast.error(msg, options),
        info: (msg, options = {}) => toast.info(msg, options),
        warning: (msg, options = {}) => toast.warning(msg, options),
        custom: toast, // full access to toast for advanced use
    };

    return (
        <ToastContext.Provider value={notify}>
          {children}
          <ToastContainer 
            position="bottom-right"
          />
        </ToastContext.Provider>
      );
}

export const useToast = () => useContext(ToastContext);